/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pickup_To_Shipping_Requires_Rerate_HelpInputs */

const en_orders_pickup_to_shipping_requires_rerate_help = /** @type {(inputs: Orders_Pickup_To_Shipping_Requires_Rerate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup to shipping requires auto-rerate. Change Only is disabled.`)
};

const es_orders_pickup_to_shipping_requires_rerate_help = /** @type {(inputs: Orders_Pickup_To_Shipping_Requires_Rerate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup a envio requiere auto-rerate. Cambiar solamente esta deshabilitado.`)
};

/**
* | output |
* | --- |
* | "Pickup to shipping requires auto-rerate. Change Only is disabled." |
*
* @param {Orders_Pickup_To_Shipping_Requires_Rerate_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_pickup_to_shipping_requires_rerate_help = /** @type {((inputs?: Orders_Pickup_To_Shipping_Requires_Rerate_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pickup_To_Shipping_Requires_Rerate_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_pickup_to_shipping_requires_rerate_help(inputs)
	return es_orders_pickup_to_shipping_requires_rerate_help(inputs)
});